// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

import React, { FC } from "react";

interface OwnProps {
    closePopup?: () => void;
}

type Props = OwnProps;

interface MiniSignInStyles {
    container?: InjectableCss;
    signInExistingAccountContainer?: InjectableCss;
    signInCreateNewAccountContainer?: ClickablePresentationProps;
}

export const miniSignInStyles: MiniSignInStyles = {};

const styles = miniSignInStyles;
const MiniSignIn: FC<Props> = ({ closePopup }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="mini-signIn">
            <StyledWrapper {...styles.signInExistingAccountContainer}>
                {createWidgetElement("SignIn/SignInExistingAccount", {
                    fields: {
                        isMiniSignIn: true,
                        closePopup,
                    },
                })}
            </StyledWrapper>
            <StyledWrapper {...styles.signInCreateNewAccountContainer}>
                {createWidgetElement("SignIn/SignInCreateNewAccount", {
                    fields: {
                        isMiniSignIn: true,
                        fullWidthButton: true,
                    },
                })}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default MiniSignIn;
